const recentStrainItems = [
  {
    id: "DBS0236123",
    name: "aarA-/[act15]:GFP-mhcA",
    dateAdded: "yesterday",
  },
  {
    id: "DBS0236123",
    name: "nhe1-",
    dateAdded: "3 days ago",
  },
  {
    id: "DBS0236123",
    name: "V30233",
    dateAdded: "last week",
  },
  {
    id: "DBS0236123",
    name: "Dictyostelium gargantuum",
    dateAdded: "2 weeks ago",
  },
]

const recentPlasmidItems = [
  {
    id: "DBP0236123",
    name: "pCpnA-GFP",
    dateAdded: "yesterday",
  },
  {
    id: "DBP0236123",
    name: "pCreCpnAKO",
    dateAdded: "3 days ago",
  },
  {
    id: "DBP0236123",
    name: "pGFP-CpnA",
    dateAdded: "last week",
  },
  {
    id: "DBP0236123",
    name: "pLoxNeoIII",
    dateAdded: "2 weeks ago",
  },
]

export { recentStrainItems, recentPlasmidItems }
